module.exports = __webpack_public_path__ + "img/h5_block03.4c6b15f2.webp";